import { publicApiClient } from '@/lib/api/client';
import type { SignupRequest, SignupResponse } from '@/features/user/types/types';

/**
 * Signup service for handling user registration
 */
export const signupService = {
  /**
   * Create a new user account
   * @param signupData - User signup information
   * @returns Promise<SignupResponse> - User data and authentication info
   */
  async signup(signupData: SignupRequest): Promise<SignupResponse> {
    try {
      const response = await publicApiClient.post<SignupResponse>(
        '/api/public/v1/public-user/signup',
        signupData
      );
      
      return response;
    } catch (error) {
      console.error('Signup error:', error);
      throw new Error('Failed to create account. Please try again.');
    }
  },

  /**
   * Verify confirmation code (for development)
   * @param code - Confirmation code
   * @returns Promise<boolean> - Whether code is valid
   */
  async verifyConfirmationCode(code: string): Promise<boolean> {
    // For development, accept "123456" as valid
    return code === '123456';
  }
};
